import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SecurityService } from '../../services/security.service';
import { RouterOutlet } from '@angular/router';
import { RouteService } from '../../services/route.service';


@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    RouterOutlet
],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent{

  showBack = signal(true);
  backRoute = signal('');
  consultor = signal<any | null>(null);
  currentRoute: string = '';

  constructor(
    private router: Router,
    private securityService: SecurityService,
    private _routeService: RouteService
  ) { 
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = event.urlAfterRedirects;
        this.showBack.set(this._routeService.compare(this.currentRoute));
        this.consultor.set(this.securityService.getConsultorInfo());
      }
    });
  }

  async back() {
    this.backRoute.set(this._routeService.getBackRoute(this.currentRoute) ?? '');
    this.router.navigateByUrl(this.backRoute());
  }
}
